import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row g-0" }
const _hoisted_3 = { class: "col align-self-center" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = { class: "d-none d-lg-block col-lg-auto" }
const _hoisted_7 = {
  href: "https://www.instagram.com/casklimahelden/",
  target: "_blank"
}
const _hoisted_8 = { class: "d-none d-lg-block col-lg-auto" }
const _hoisted_9 = {
  href: "https://www.facebook.com/CASKlimahelden/",
  target: "_blank"
}
const _hoisted_10 = { class: "col text-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-end d-none d-lg-block col-md" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Jetzt CAS", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "werden", -1)
const _hoisted_15 = { class: "text-end col d-lg-none" }
const _hoisted_16 = { class: "w-auto ms-auto d-inline-block" }
const _hoisted_17 = { class: "row g-4" }
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = {
  href: "https://www.instagram.com/casklimahelden/",
  target: "_blank"
}
const _hoisted_20 = { class: "col-auto" }
const _hoisted_21 = {
  href: "https://www.facebook.com/CASKlimahelden/",
  target: "_blank"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "Jetzt CAS", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("b", null, "werden", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarButton = _resolveComponent("SidebarButton")!
  const _component_ButtonIconRound = _resolveComponent("ButtonIconRound")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IoSidebar = _resolveComponent("IoSidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      style: _normalizeStyle(`top:${_ctx.header.top}px`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_SidebarButton, { onClick: _ctx.toggleSidebar }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", _hoisted_7, [
                  _createVNode(_component_ButtonIconRound, {
                    icon: "fab fa-instagram",
                    title: "Instagram"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", _hoisted_9, [
                  _createVNode(_component_ButtonIconRound, {
                    icon: "fab fa-facebook-f",
                    title: "Facebook"
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/",
              custom: ""
            }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("div", {
                  ref: "logo",
                  class: "klimahelden-logo",
                  onClick: navigate
                }, null, 8, _hoisted_11)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.hasKlimaheldSection)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-hero",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToKlimaheld && _ctx.scrollToKlimaheld(...args)))
                }, [
                  _hoisted_13,
                  _createTextVNode("Klimaheld "),
                  _hoisted_14
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("a", _hoisted_19, [
                    _createVNode(_component_ButtonIconRound, {
                      icon: "fab fa-instagram",
                      title: "Instagram"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("a", _hoisted_21, [
                    _createVNode(_component_ButtonIconRound, {
                      icon: "fab fa-facebook-f",
                      title: "Facebook"
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.hasKlimaheldSection)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-hero btn-hero__mobile d-lg-none",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollToKlimaheld && _ctx.scrollToKlimaheld(...args)))
          }, [
            _hoisted_22,
            _createTextVNode("Klimaheld "),
            _hoisted_23
          ]))
        : _createCommentVNode("", true)
    ], 4),
    _createVNode(_component_IoSidebar)
  ], 64))
}